var map = {
	"./3E3C1BD6-13A5-454E-83BB-FB76F068D72F.jpg": 2095,
	"./70796EF9-4693-4A8E-B37C-118C5C882BB0.jpg": 33,
	"./80957543-501F-4913-B048-7D09F92FEBA2.jpg": 2757,
	"./B28466E8-A519-47FB-B92E-5127F8E3357D.jpg": 3596,
	"./IMG_0952.jpg": 5691,
	"./IMG_0953.jpg": 9194,
	"./IMG_0958.jpg": 3351,
	"./IMG_0960.jpg": 4765,
	"./IMG_0961.jpg": 421,
	"assets/photo/reportage/10-12/3E3C1BD6-13A5-454E-83BB-FB76F068D72F.jpg": 2095,
	"assets/photo/reportage/10-12/70796EF9-4693-4A8E-B37C-118C5C882BB0.jpg": 33,
	"assets/photo/reportage/10-12/80957543-501F-4913-B048-7D09F92FEBA2.jpg": 2757,
	"assets/photo/reportage/10-12/B28466E8-A519-47FB-B92E-5127F8E3357D.jpg": 3596,
	"assets/photo/reportage/10-12/IMG_0952.jpg": 5691,
	"assets/photo/reportage/10-12/IMG_0953.jpg": 9194,
	"assets/photo/reportage/10-12/IMG_0958.jpg": 3351,
	"assets/photo/reportage/10-12/IMG_0960.jpg": 4765,
	"assets/photo/reportage/10-12/IMG_0961.jpg": 421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7908;